export default __webpack_public_path__ + "static/media/leftLayer.9d1e7251.png";